import {Navigate} from "react-router-dom";
import {Box, CircularProgress} from "@mui/material";
import {useAuth} from "../context/AuthContext";

const HomeRoute = () => {
    const {user, isLoading, hasRole} = useAuth();

    if (isLoading) {
        return (
            <Box sx={{display: "flex", justifyContent: "center", mt: 6}}>
                <CircularProgress/>
            </Box>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace/>;
    }
    if (hasRole("ROLE_STUDENT") || hasRole("ROLE_TEACHER")) {
        return <Navigate to="/my-courses" replace/>;
    } else if (hasRole("ROLE_COMPANY_ADMIN") || hasRole("ROLE_COMPANY_STUDENT") || hasRole("ROLE_COMPANY_TEACHER")) {
        return <Navigate to="/company-courses" replace/>;
    }
    return <Navigate to="/courses" replace/>;
};

export default HomeRoute;
